/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";

export default class DisasterRecovery extends React.Component {
  abortController = new AbortController();

  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false,
    };
  }

  componentDidMount = () => {
    fetch(
      `/services/getDRJSON?drGroupId=${this.props.module.disasterRecoveryGroup.id}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "GET",
        cache: "no-cache",
        signal: this.abortController.signal,
      },
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((resp) => {
        const drResponse = resp.response;
        this.setState({ loaded: true, drGroup: drResponse });
      });
  };

  componentWillUnmount = () => {
    this.abortController.abort();
  };

  render() {
    return (
      <SummaryItem itemKey="Disaster Recovery: ">
        <SectionItem itemKey="DR Group">
          {this.state.loaded ? (
            <span>
              {this.state.drGroup.disasterRecoveryGroup
                ? this.state.drGroup.disasterRecoveryGroup.name
                : "DR Group not found"}
            </span>
          ) : (
            <img src="/_client/images/global/ui-loader-1.gif" />
          )}
        </SectionItem>
        <SectionItem itemKey="Status">
          {this.state.loaded && (
            <span>
              {this.state.drGroup.disasterRecoveryGroup
                ? this.state.drGroup.disasterRecoveryGroup.status
                  ? "Active"
                  : "In-Active"
                : "N/A"}
            </span>
          )}
        </SectionItem>
      </SummaryItem>
    );
  }
}

DisasterRecovery.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
